import Typography from '@lno/core/components/Typography'
import { styles } from '../styles'
export const jsxScope = `jsx-${styles.__hash}`

const DesenrolaNorthEastCampaign = () => (
  <div className="content-wrapper">
    <Typography size="bodyM" color="medium" tag="p">
      Sim. Além das ofertas do Desenrola para todo o Brasil, a Serasa preparou
      uma ação inédita pós-Carnaval para os moradores do Nordeste, população que
      vive um ciclo econômico diferenciado nesta época de verão e folia.
    </Typography>
    <br />
    <Typography size="bodyM" color="medium" tag="p">
      De 15 a 29 de fevereiro serão disponibilizadas ofertas exclusivas na
      região com a possibilidade de negociar dívidas de contas básicas com
      destaque para concessionárias Enel, Equatorial, Neoenergia Coelba,
      Neoenergia Pernambuco, Neoenergia Cosern e Energisa com condições
      especiais.
    </Typography>
  </div>
)

export const CampaignDescription = () => {
  const Component = DesenrolaNorthEastCampaign

  return <Component />
}
